/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotUserMetric extends models.CopilotLinesOfCodeSummaryBase {
    getFixupPrototypeFunction() { return CopilotUserMetric.fixupPrototype; }

    static newInstance(model: Partial<CopilotUserMetric>): CopilotUserMetric {
        let obj = Object.assign(new CopilotUserMetric(), model);
        CopilotUserMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotUserMetric>): CopilotUserMetric {
        if (!model) return null;
        return CopilotUserMetric.newInstance(<CopilotUserMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotUserMetric) {
        if (!obj) return;

        models.CopilotUserMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotUserMetric): boolean {
        if (models.CopilotLinesOfCodeSummaryBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotUserMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.github_user_id === undefined) {
            this.github_user_id = 0;
        }
        if (this.user_initiated_interaction_count === undefined) {
            this.user_initiated_interaction_count = 0;
        }
        if (this.totals_by_feature) {
            for (let val of this.totals_by_feature) {
                models.CopilotTotalsByFeature.fixupPrototype(val);
            }
        }
        if (this.totals_by_ide) {
            for (let val of this.totals_by_ide) {
                models.CopilotTotalsByIde.fixupPrototype(val);
            }
        }
        if (this.totals_by_language_model) {
            for (let val of this.totals_by_language_model) {
                models.CopilotTotalsByLanguageModel.fixupPrototype(val);
            }
        }
        if (this.totals_by_model_feature) {
            for (let val of this.totals_by_model_feature) {
                models.CopilotTotalsByModelFeature.fixupPrototype(val);
            }
        }
    }

    /**
     * Activity totals grouped by feature
     */
    totals_by_feature: Array<models.CopilotTotalsByFeature>;

    /**
     * Activity totals grouped by IDE
     */
    totals_by_ide: Array<models.CopilotTotalsByIde>;

    /**
     * Activity totals grouped by programming language and AI model
     */
    totals_by_language_model: Array<models.CopilotTotalsByLanguageModel>;

    /**
     * Activity totals grouped by model and feature
     */
    totals_by_model_feature: Array<models.CopilotTotalsByModelFeature>;

    /**
     * GitHub user ID
     */
    github_user_id: number;

    /**
     * Number of user initiated interactions
     */
    user_initiated_interaction_count: number;

    /**
     * GitHub username of the user
     */
    github_username: string;

}
